// src/store/services/ReferenciasHistorico.js
import feathersClient, {
    makeServicePlugin,
    BaseModel,
  } from '../../feathers-client';
  
  class ReferenciasHistorico extends BaseModel {
    constructor(data, options) {
      super(data, options);
    }
    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'ReferenciasHistorico';
    // Define default properties here
    static instanceDefaults() {
      return {};
    }
  }
  const servicePath = 'referencias-historico';
  const servicePlugin = makeServicePlugin({
    namespaced: true,
    namespace: 'ReferenciasHistorico',
    Model: ReferenciasHistorico,
    service: feathersClient.service(servicePath),
    servicePath,
  });
  
  // Setup the client-side Feathers hooks.
  feathersClient.service(servicePath).hooks({
    before: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: [],
    },
    after: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: [],
    },
    error: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: [],
    },
  });
  
  export default servicePlugin;
  